import { PencilSimple } from "@phosphor-icons/react"
import { PotentiallyUnsafeInnerHtml } from "@/components/potentially-unsafe-inner-html"
import { joinStrings } from "@/lib/joinString"
import { normalizeTestId } from "@/lib/test-helper"
import { cn } from "@/lib/utils"
import { deMedicationFragmentInline$data } from "@/modules/patients/detail/medication/de/services/__generated__/deMedicationFragmentInline.graphql"
import { generateMedicationDescription } from "@/modules/patients/detail/medication/lib/generate-medication-description"
import { isFreeTextMedicationType } from "@/modules/patients/detail/medication/lib/is-free-text-medication-type"

interface MedicationItemProps {
  isActive?: boolean
  medicationData: deMedicationFragmentInline$data
  handleSelectExistingMedication: (medication: deMedicationFragmentInline$data) => void
  ref?: React.Ref<HTMLButtonElement>
}

export const MedicationItem = (props: MedicationItemProps) => {
  const { isActive = false, medicationData, handleSelectExistingMedication, ref } = props
  const { id, name, composition, type } = medicationData

  const medicationDescription = generateMedicationDescription({ isActive, ...medicationData })

  return (
    <button
      data-testid={normalizeTestId("medication-item-", String(id))}
      ref={ref}
      className="group hover:bg-surface-hovered active:bg-surface-pressed relative flex min-h-12 w-full items-center gap-2 overflow-hidden rounded-md px-2 py-1.5 text-left transition-all duration-300"
      onClick={() => handleSelectExistingMedication(medicationData)}>
      <div className="overflow-hidden">
        <PotentiallyUnsafeInnerHtml
          className={cn(
            "text-on-surface truncate text-sm leading-5 whitespace-nowrap",
            isFreeTextMedicationType(type) && "pr-1 italic",
          )}
          title={name}
          value={joinStrings([name, composition ?? ""])}
        />
        <p className="text-on-surface-subdued truncate text-xs leading-4 tracking-[0.25px]">{medicationDescription}</p>
      </div>
      <span className="ml-auto">
        <span className="text-on-surface-subdued hover:bg-surface-subdued-hovered hidden h-9 w-9 shrink-0 items-center justify-center rounded-full transition-all duration-300 group-hover:flex">
          <PencilSimple />
        </span>
      </span>
    </button>
  )
}
